import "./rentals.css";
import { Link } from "react-router-dom";
import RentalBasket from "../../components/common/Basket/RentalBasket";
import RentalItem from "../../components/rentalService/RentalItem";
import { useSelector } from "react-redux";
import templeJson from "../../config/temple.json";
import { Container, Grid } from "@mui/material";
import useRentals from "./customHook";

function Rentals() {
  const { rentalData, purposes } = useRentals();
  const rentCartArr = useSelector((state) => state.rentArr);

  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">Rentals</h1>
        <ol className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">Rentals</Link>
          </li>
          <li className="breadcrumb-item active">Rentals</li>
        </ol>
      </Container>
      <Container className="py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            {templeJson["templeName"]}{" "}
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Rentals</span>
          </h1>
        </Grid>

        <Grid container spacing={2}>
          <Grid item lg={8} md={8}>
            {rentalData
              ? rentalData?.map((item) => {
                  return (
                    <RentalItem
                      item={item}
                      key={item._id}
                      purposes={purposes}
                    />
                  );
                })
              : null}
          </Grid>

          <Grid item lg={4} md={4} className=" rental-basket">
            <RentalBasket />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Rentals;
